var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mx-auto"},[_c('elements-menu',{ref:"elementsMenu",attrs:{"substep":_vm.substep}}),(_vm.localModel && _vm.activePresetId && _vm.activePreset.styles && _vm.ready)?_c('groovemail-form',{attrs:{"substep":_vm.substep,"model":_vm.localModel}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }